import api from './api';

const partnerSsoService = {
    getProviders: async (partnerId) => {
        const response = await api.get(`/partner-sso?partnerId=${partnerId}`);
        return response.data;
    },

    saveProvider: async (data) => {
        const response = await api.post('/partner-sso', data);
        return response.data;
    },

    configureProvider: async (id) => {
        const response = await api.post(`/partner-sso/${id}/configure`);
        return response.data;
    },

    deleteProvider: async (id) => {
        const response = await api.delete(`/partner-sso/${id}`);
        return response.data;
    },
};

export default partnerSsoService;
